module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-36-min.54507ad0.jpg";